module.exports = __webpack_public_path__ + "img/4.16fc4cb7.png";